export default __webpack_public_path__ + "static/media/CM_loader.1d5daf0e.gif";